// These are the domain entity types that will use the reduced rate limit since they "talk" directly to contentful right now which has strict rate limits.
export const REDUCED_RATE_LIMIT_DOMAIN_ENTITY_TYPES = new Set([
  'config-image',
  'config-pdf',
]);

export const REDUCED_RATE_LIMIT_INTERVAL_MS = 400;

export const shouldUseReducedRateLimit = (
  domainEntityType: string | undefined,
) => REDUCED_RATE_LIMIT_DOMAIN_ENTITY_TYPES.has(domainEntityType ?? '');
